module.exports = "<div class=c-loginout ng-class=\"{'c-loginout--allowed': $ctrl.isLoginAllowed(), 'c-loginout--logged-in': $ctrl.isLoggedIn()}\"> <button class=\"c-loginout__action c-login / t-text--secondary--action\" ng-click=$ctrl.login()>Log in</button> <button class=\"c-loginout__action c-logout / t-text--secondary--action\" ng-click=$ctrl.logout()>Log out <span class=c-logout__tooltip>Logged in as: {{ $ctrl.storeService.get('client_name') }}</span> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/logInOut.html
// module id = 788
// module chunks = 0